import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { Container } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../Context/AuthContext";
import Preloader from "../../shared/PreLoaders";
import TableComponent from "../../utils/TableComponent";
import { Authorization } from "../../Context/Authorization";

const Manage = () => {
  const [vfcData, setVfcData] = useState([]);
  const navigate = useNavigate();
  const { permissions } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    setLoading(true);
    const fetchVfc = async () => {
      try {
        const Config = Authorization();
        const response = await axios.get(`${Api}/api/vfcs`, Config);
        const data = response.data.vfcs;
        setVfcData(data);
      } catch (error) {
        console.log("Error fetching Data", error);
      }
      setLoading(false);
    };
    fetchVfc();
  }, [Api]);

  const handleDeleteVfc = async (id) => {
    try {
      const Config = Authorization();
      await axios.delete(`${Api}/api/vfcs/${id}`, Config);
      setVfcData(vfcData.filter((state) => state._id !== id));
      toast.success("Deleted Successfully");
    } catch (err) {
      console.error("Error deleting VFC", err);
      toast.error("Failed to delete VFC");
    }
  };

  const handleEditVfc = (id) => {
    navigate(`edit/${id}`);
  };

  const handleAddVfc = () => {
    navigate("vfc/add");
  };

  const columns = [
    {
      headerName: "Action",
      field: "action",
      cellRenderer: (params) => (
        <div>
          {permissions.includes("EditVfc") && (
            <i
              className="mdi mdi-pen"
              style={{ fontSize: "1.5rem", cursor: "pointer" }}
              onClick={() => handleEditVfc(params.data._id)}
            />
          )}
        </div>
      ),
    },
    {
      headerName: "SI.No",
      field: "index",
      valueGetter: (params) => params.node.rowIndex + 1,
    },
    {
      headerName: "VFC Name",
      field: "vfcName",
    },
    {
      headerName: "Range Code",
      field: "rangeId.rangeName",
    },
    {
      headerName: "Location",
      field: "location",
    },
    {
      headerName: "Address",
      field: "address",
    },
    {
      headerName: "Village",
      field: "village",
    },
    {
      headerName: "Panchayath",
      field: "panchayath",
    },
    {
      headerName: "Thaluk",
      field: "thaluk",
    },
    {
      headerName: "Pin Code",
      field: "pinCode",
    },
    {
      headerName: "Date of Establishment",
      field: "dateOfEstablishment",
      valueFormatter: (params) => new Date(params.value).toLocaleDateString(),
    },
    {
      headerName: "Bank Name",
      field: "bankName",
    },
    {
      headerName: "Branch",
      field: "branch",
    },
    {
      headerName: "A/c No",
      field: "accountNumber",
    },
    {
      headerName: "IFSC Code",
      field: "ifscCode",
    },
    {
      headerName: "Registration No",
      field: "registrationNo",
    },
    {
      headerName: "Registration Date",
      field: "registrationDate",
      valueFormatter: (params) => new Date(params.value).toLocaleDateString(),
    },
    {
      headerName: "Total Family",
      field: "totalFamily",
    },
    {
      headerName: "Total Population",
      field: "totalPopulation",
    },
    {
      headerName: "VFC Family",
      field: "vfcFamily",
    },
    {
      headerName: "Action",
      field: "action",
      cellRenderer: (params) => (
        <div>
          {permissions.includes("EditVfc") &&
            permissions.includes("DeleteVfc") && (
              <>
                <i
                  className="mdi mdi-pen"
                  style={{
                    fontSize: "1.5rem",
                    cursor: "pointer",
                  }}
                  onClick={() => handleEditVfc(params.data._id)}
                />
                <i
                  className="mdi mdi-delete"
                  style={{
                    fontSize: "1.5rem",
                    cursor: "pointer",
                  }}
                  onClick={() => handleDeleteVfc(params.data._id)}
                />
              </>
            )}
        </div>
      ),
    },
  ];

  return (
    <div>
      <Preloader loading={loading} />
      <div className="page-header">
        <h3 className="page-title"> All VFC </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="!#" onClick={(event) => event.preventDefault()}>
                VFC
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              All VFC
            </li>
          </ol>
        </nav>
      </div>

      <Container fluid className="mt-5">
        <div className="card">
          <div className="card-body">
            <div className="row icons-list">
              {permissions.includes("AddVfc") && (
                <div className="Add_btn">
                  <button
                    type="button"
                    className="btn btn-inverse-success "
                    onClick={handleAddVfc}
                  >
                    Create New
                  </button>
                </div>
              )}
              <div className="table-responsive">
                <TableComponent data={vfcData} columns={columns} />
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Manage;
